import { Helper } from '@/mixin/helper'
const fields = [
  {
    label: 'Nama Kategori Biaya',
    key: 'activity.name',
  },
  {
    label: 'Tanggal Transaksi',
    key: 'date',
    isSortable: true,
  },
  {
    label: 'No. Dokumen Biaya',
    key: 'number',
    isSortable: true,
  },
  {
    label: 'Jenis Biaya',
    key: 'reference_type',
    thAttr: {
      style: 'min-width:200px;',
    }
  },
  {
    label: 'No. Penugasan',
    key: 'fleet_task.number',
  },
  {
    label: 'Plat Nomor',
    key: 'vehicle.license_plate',
  },
  {
    label: 'Biaya',
    key: 'amount',
    tdAttr: {
      style: 'text-align: right;'
    },
    formatter: (val) => {
      return val ? 'Rp. ' + Helper.methods.thousandFormat(val) : '-'
    },
  },
  {
    label: 'Dokumen Pendukung',
    key: 'attachment',
  },
]

export default fields
